export const CYCLES = 'cycles';

export const ACTIVITY_KIND = {
    STANDARD: 'STANDARD',
    SABBATICAL: 'SABBATICAL',
    PLACEHOLDER: 'PLACEHOLDER',
    GATEWAY: 'GATEWAY',
}

export const DEFAULT_CYCLE_PLACEHOLDER_COUNT = 6

export const getDefaultCycleFlow = () => [
    ...Array.from({ length: DEFAULT_CYCLE_PLACEHOLDER_COUNT }, () => ({
        kind: ACTIVITY_KIND.PLACEHOLDER,
    })),
    { kind: ACTIVITY_KIND.SABBATICAL, name: "Sabbatical" },
]

export const isSabbaticalActivity = (activity) => activity?.kind === ACTIVITY_KIND.SABBATICAL

export const isPlaceholderActivity = (activity) => activity?.kind === ACTIVITY_KIND.PLACEHOLDER

export const isGatewayActivity = (activity) => activity?.kind === ACTIVITY_KIND.GATEWAY

export const firstPlaceholderActivity = (cycle) =>
    (cycle?.flow || []).find(isPlaceholderActivity)
